export interface SubscriptionPlan {
    id: string;
    name: string;
    priceId: string;
    features: string[];
    internal?: boolean;  // true = hidden from customer-facing UI, active on Stripe for internal use only
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
    {
        id: 'solo_flex',
        name: 'Solo Flex',
        priceId: import.meta.env.VITE_PRICE_SOLO_FLEX,
        features: ['Single Provider', 'Pay-as-you-go ($1.50/PDF)', 'No monthly fee']
    },
    {
        id: 'test_free',
        name: 'Test Plan (Free)',
        priceId: import.meta.env.VITE_PRICE_TEST_FREE,
        features: ['FREE for testing', 'No charges', 'Test subscription flow'],
        internal: true,
    },
    {
        id: 'clinic_essential',
        name: 'Clinic Essential',
        priceId: import.meta.env.VITE_PRICE_CLINIC_ESSENTIAL,
        features: ['Up to 5 Providers', '$25/month (Includes 25 PDFs)', '$1.00/PDF overage']
    },
    {
        id: 'practice_pro',
        name: 'Practice Pro',
        priceId: import.meta.env.VITE_PRICE_PRACTICE_PRO,
        features: ['Up to 20 Providers', '$75/month (Includes 100 PDFs)', '$0.75/PDF overage']
    },
    {
        id: 'group_scale',
        name: 'Group Scale',
        priceId: import.meta.env.VITE_PRICE_GROUP_SCALE,
        features: ['Unlimited Providers', '$200/month (Includes 400 PDFs)', '$0.50/PDF overage']
    },
    {
        id: 'facesheetapp_enterprise',
        name: 'FaceSheetApp Enterprise',
        priceId: import.meta.env.VITE_PRICE_ENTERPRISE,
        features: ['White Labeling', '$400/month (Includes 1600 PDFs)', '$0.25/PDF overage']
    }
];
